"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsOfServiceContribution = exports.DocsDeploymentHelmContribution = exports.DocsDeploymentDockerContribution = exports.DocsDeploymentDevelopmentEnvironmentContribution = exports.DocsFrameworkOperationsContribution = exports.DocsFrameworkContributionsContribution = exports.DocsFrameworkRoutingContribution = exports.DocsFrameworkGuideContribution = exports.DocsLicenseOperatorOpenApiContribution = exports.DocsLicenseOperatorNatsEventsContribution = exports.DocsLicenseOperatorConfigurationContribution = exports.DocsLicenseOperatorOverviewContribution = exports.DocsAuthContainerOpenApiContribution = exports.DocsAuthContainerNatsEventsContribution = exports.DocsAuthContainerCommandsContribution = exports.DocsAuthContainerConfigurationContribution = exports.DocsAuthContainerOverviewContribution = exports.DocsGettingStartedPageContribution = void 0;
const react_1 = __importDefault(require("react"));
const inversify_1 = require("inversify");
const routes_1 = require("@authlance/core/lib/common/routes/routes");
const lucide_react_1 = require("lucide-react");
const DOC_FALLBACK = react_1.default.createElement("div", { className: "text-sm text-muted-foreground" }, "Loading documentation\u2026");
const SWAGGER_UI_STYLE_ID = 'auth-container-swagger-ui-overrides';
const SWAGGER_UI_OVERRIDE_CSS = `
.swagger-ui,
.swagger-ui .wrapper {
    background-color: transparent;
    color: hsl(var(--foreground));
    font-family: var(--font-sans, 'Inter'), ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', sans-serif;
}

.swagger-ui .topbar {
    display: none;
}

.swagger-ui .info {
    margin-bottom: 1.5rem;
}

.swagger-ui .info .title,
.swagger-ui .info .base-url {
    color: hsl(var(--foreground));
}

.swagger-ui .scheme-container {
    background-color: transparent;
    border: 1px solid hsl(var(--border));
    border-radius: 0.75rem;
    box-shadow: none;
    margin: 0 0 1.5rem;
    padding: 1rem;
}

.swagger-ui .opblock-tag-section {
    border-color: hsl(var(--border));
}

.swagger-ui .opblock-tag {
    font-size: 1rem;
    font-weight: 600;
    color: hsl(var(--foreground));
}

.swagger-ui .opblock-tag small {
    color: hsl(var(--muted-foreground));
}

.swagger-ui .opblock {
    border-radius: 0.75rem;
    border-color: hsl(var(--border));
    background-color: hsl(var(--card));
    color: hsl(var(--card-foreground));
}

.swagger-ui .opblock .opblock-summary-description {
    color: hsl(var(--muted-foreground));
}

.swagger-ui .btn.execute {
    border-radius: 0.375rem;
    font-weight: 600;
}

.swagger-ui .model-box {
    background-color: hsl(var(--muted));
    color: hsl(var(--muted-foreground));
    border-radius: 0.75rem;
}

.swagger-ui .parameter__name {
    color: hsl(var(--foreground));
}

.swagger-ui .parameter__type {
    color: hsl(var(--muted-foreground));
}

.swagger-ui .response-col_description__inner span {
    color: hsl(var(--muted-foreground));
}
`;
const AUTH_CONTAINER_CATEGORY = new routes_1.RouteCategory('Auth Container', react_1.default.createElement(lucide_react_1.ShieldCheck, null), 10);
const LICENSE_OPERATOR_CATEGORY = new routes_1.RouteCategory('License Operator', react_1.default.createElement(lucide_react_1.Key, null), 20);
const FRAMEWORK_CATEGORY = new routes_1.RouteCategory('Extend Authlance', react_1.default.createElement(lucide_react_1.Layers, null), 30);
const DEPLOYMENT_CATEGORY = new routes_1.RouteCategory('Deployment', react_1.default.createElement(lucide_react_1.Server, null), 40);
const DOCS_TITLE_SUFFIX = 'Authlance Docs';
const DOCS_CANONICAL_BASE_URL = resolveDocsCanonicalBaseUrl();
const DOCS_PRERENDER_FALLBACK = { enabled: true };
const AUTH_CONTAINER_OPENAPI_ENTRY = {
    path: '/docs/auth-container/openapi',
    title: 'Auth Container API Reference',
    description: 'Interactive Swagger UI for exploring and testing the identity endpoints served by the Auth Container.',
    keywords: ['Auth Container API', 'OpenAPI', 'Swagger UI', 'identity API'],
};
const LICENSE_OPERATOR_OPENAPI_ENTRY = {
    path: '/docs/license-operator/openapi',
    title: 'License Operator API Reference',
    description: 'Interactive Swagger docs for license issuance endpoints surfaced by the License Operator.',
    keywords: ['License Operator API', 'OpenAPI', 'Swagger UI', 'licensing API'],
};
const DOCS_SEO_ENTRIES = [
    {
        path: '/docs',
        title: 'Getting Started with Authlance',
        description: 'Understand how Authlance combines authentication, licensing, and dashboards, review prerequisites, and launch a local stack quickly.',
        keywords: ['Authlance docs', 'getting started', 'self-hosted auth', 'licensing platform'],
    },
    {
        path: '/docs/auth-container/overview',
        title: 'Auth Container Overview',
        description: 'Dive into the Auth Container responsibilities across session exchange, Stripe webhooks, automation, and the lifecycle events it emits.',
        keywords: ['Auth container', 'identity gateway', 'Stripe webhooks', 'Authlance docs'],
    },
    {
        path: '/docs/auth-container/configuration',
        title: 'Auth Container Configuration',
        description: 'Field-by-field reference for the Auth container config.yaml covering Kratos/Hydra URLs, secrets, Stripe, backups, mail relay, and S3 settings.',
        keywords: ['Auth container config', 'config.yaml', 'identity settings', 'Authlance docs'],
    },
    {
        path: '/docs/auth-container/commands',
        title: 'Auth Container Commands',
        description: 'Command reference for the auth runtime binaries—including serve, backup, load-backup, stripe-webhook, and the authlancectl admin client.',
        keywords: ['Authlance CLI', 'authlancectl', 'Auth container', 'command reference'],
    },
    {
        path: '/docs/auth-container/nats-events',
        title: 'Auth Container NATS Events',
        description: 'Catalog of JetStream subjects the Auth container publishes for logins, subscriptions, payments, and license lifecycle automation.',
        keywords: ['Authlance events', 'NATS JetStream', 'identity signals'],
    },
    AUTH_CONTAINER_OPENAPI_ENTRY,
    {
        path: '/docs/license-operator/overview',
        title: 'License Operator Overview',
        description: 'Overview of the Authlance License Operator service, covering Stripe automation, product catalog APIs, issuance flows, and operational hooks.',
        keywords: ['License operator', 'Stripe automation', 'Authlance licensing'],
    },
    {
        path: '/docs/license-operator/configuration',
        title: 'License Operator Configuration',
        description: 'Detailed guide to the license operator config file including security keys, Stripe secrets, quotas, webhook guarantees, and trial enforcement.',
        keywords: ['License operator config', 'Stripe webhooks', 'self-hosted licensing'],
    },
    {
        path: '/docs/license-operator/nats-events',
        title: 'License Operator NATS Events',
        description: 'Reference for the licenseoperator.license.issued JetStream subject, delivery semantics, and payload schema emitted after every paid issuance.',
        keywords: ['License issued event', 'NATS JetStream', 'Authlance licensing'],
    },
    LICENSE_OPERATOR_OPENAPI_ENTRY,
    {
        path: '/docs/framework/extending-authlance',
        title: 'Authlance Extension Guide',
        description: 'High-level tour of Authlance extension points linking to layout, routing, and prerender chapters so you can shape a branded dashboard.',
        keywords: ['Authlance extension', 'custom dashboard', 'loop scaffold'],
    },
    {
        path: '/docs/framework/extending-authlance-routing',
        title: 'Routing & Metadata',
        description: 'Explains RoutesApplicationContribution, categories, and SEO document hooks for building structured navigation with canonical metadata.',
        keywords: ['Authlance routing', 'navigation', 'SEO metadata'],
    },
    {
        path: '/docs/framework/extending-authlance-contributions',
        title: 'Prerender & Runtime Contributions',
        description: 'Deep dive on prerender contexts, cache contributions, and user/group action providers that power runtime customization.',
        keywords: ['Prerender cache', 'Authlance contributions', 'QueryClient'],
    },
    {
        path: '/docs/framework/extending-authlance-operations',
        title: 'Layout, Branding & Operations',
        description: 'Covers layout hooks, theming, package publishing, and dev workflows required to operate and ship a branded Authlance dashboard.',
        keywords: ['Authlance theming', 'dashboard layout', 'loop operations'],
    },
    {
        path: '/docs/deployment/development-environment',
        title: 'Development Environment Setup',
        description: 'Connect the docker-compose backend with the Loop Scaffold dashboard, render synchronized configs, and iterate locally against the same stack as production.',
        keywords: ['development environment', 'Loop Scaffold', 'Compose backend'],
    },
    {
        path: '/docs/deployment/docker-compose',
        title: 'Docker Compose Deployment',
        description: 'Step-by-step instructions for running the entire Authlance stack via docker-compose for demos, development, and staging environments.',
        keywords: ['Docker Compose', 'Authlance deployment', 'local stack'],
    },
    {
        path: '/docs/deployment/helm-charts',
        title: 'Helm Chart Deployment',
        description: 'Guide to deploying Authlance and the License Operator with the provided Helm charts, values overrides, and day-two operations.',
        keywords: ['Helm chart', 'Kubernetes', 'Authlance deployment'],
    },
    {
        path: '/terms-of-service',
        title: 'Authlance Terms of Service',
        description: 'Read the Authlance terms covering licensing, deployment responsibilities, warranty disclaimers, and privacy notes for self-hosted use.',
        keywords: ['Authlance terms', 'self-hosted licensing terms', 'privacy policy'],
    },
];
const DOCS_PRERENDER_BY_PATH = DOCS_SEO_ENTRIES.reduce((acc, entry) => {
    acc[entry.path] = {
        enabled: true,
        document: buildDocDocument(entry),
    };
    return acc;
}, {});
const DOCS_AUTH_CONTAINER_OPENAPI_PRERENDER = Object.assign(Object.assign({}, ((_a = DOCS_PRERENDER_BY_PATH[AUTH_CONTAINER_OPENAPI_ENTRY.path]) !== null && _a !== void 0 ? _a : {
    document: buildDocDocument(AUTH_CONTAINER_OPENAPI_ENTRY),
})), { enabled: false });
const DOCS_LICENSE_OPERATOR_OPENAPI_PRERENDER = Object.assign(Object.assign({}, ((_b = DOCS_PRERENDER_BY_PATH[LICENSE_OPERATOR_OPENAPI_ENTRY.path]) !== null && _b !== void 0 ? _b : {
    document: buildDocDocument(LICENSE_OPERATOR_OPENAPI_ENTRY),
})), { enabled: false });
function getDocPrerenderConfig(path) {
    var _a;
    return (_a = DOCS_PRERENDER_BY_PATH[path]) !== null && _a !== void 0 ? _a : DOCS_PRERENDER_FALLBACK;
}
function buildDocDocument(entry) {
    const normalizedPath = normalizeDocPath(entry.path);
    const canonicalUrl = `${DOCS_CANONICAL_BASE_URL}${normalizedPath}`;
    const pageTitle = `${entry.title} — ${DOCS_TITLE_SUFFIX}`;
    const metaCandidates = [
        entry.description
            ? {
                attributes: {
                    name: 'description',
                    content: entry.description,
                },
            }
            : undefined,
        entry.keywords && entry.keywords.length > 0
            ? {
                attributes: {
                    name: 'keywords',
                    content: entry.keywords.join(', '),
                },
            }
            : undefined,
        {
            attributes: {
                property: 'og:title',
                content: pageTitle,
            },
        },
        entry.description
            ? {
                attributes: {
                    property: 'og:description',
                    content: entry.description,
                },
            }
            : undefined,
        {
            attributes: {
                property: 'og:type',
                content: 'article',
            },
        },
        {
            attributes: {
                property: 'og:url',
                content: canonicalUrl,
            },
        },
        {
            attributes: {
                name: 'twitter:card',
                content: 'summary',
            },
        },
        {
            attributes: {
                name: 'twitter:title',
                content: pageTitle,
            },
        },
        entry.description
            ? {
                attributes: {
                    name: 'twitter:description',
                    content: entry.description,
                },
            }
            : undefined,
        {
            attributes: {
                name: 'twitter:url',
                content: canonicalUrl,
            },
        },
    ];
    const meta = metaCandidates.filter((tag) => { var _a; return Boolean(tag && ((_a = tag.attributes) === null || _a === void 0 ? void 0 : _a.content)); });
    const links = [
        {
            attributes: {
                rel: 'canonical',
                href: canonicalUrl,
            },
        },
    ];
    return {
        title: pageTitle,
        meta,
        links,
    };
}
function normalizeDocPath(path) {
    if (!path) {
        return '/docs';
    }
    return path.startsWith('/') ? path : `/${path}`;
}
function resolveDocsCanonicalBaseUrl() {
    var _a;
    const env = typeof process !== 'undefined' ? (_a = process.env) !== null && _a !== void 0 ? _a : {} : {};
    const raw = (typeof env.AUTHLANCE_PUBLIC_URL === 'string' && env.AUTHLANCE_PUBLIC_URL.trim()) ||
        (typeof env.ROOT_APP_URL === 'string' && env.ROOT_APP_URL.trim()) ||
        (typeof env.APP_URL === 'string' && env.APP_URL.trim()) ||
        'https://authlance.com';
    return raw.replace(/\/+$/, '') || 'https://authlance.com';
}
function createDocPage(loader, serverModuleId) {
    const LazyDocComponent = react_1.default.lazy(loader);
    const DocPage = () => {
        if (typeof window === 'undefined') {
            const ServerDocComponent = loadDocForServer(serverModuleId);
            return (react_1.default.createElement("article", { className: "prose prose-slate dark:prose-invert" },
                react_1.default.createElement(ServerDocComponent, null)));
        }
        return (react_1.default.createElement("article", { className: "prose prose-slate dark:prose-invert" },
            react_1.default.createElement(react_1.default.Suspense, { fallback: DOC_FALLBACK },
                react_1.default.createElement(LazyDocComponent, null))));
    };
    return DocPage;
}
function loadDocForServer(moduleId) {
    const nodeRequire = resolveNodeRequire();
    const loaded = nodeRequire(moduleId);
    return resolveDocModule(loaded);
}
function resolveNodeRequire() {
    if (typeof __docs_require__ === 'function') {
        return __docs_require__;
    }
    if (typeof __non_webpack_require__ === 'function') {
        return __non_webpack_require__;
    }
    try {
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        const fallback = Function('return require')();
        return fallback;
    }
    catch (_a) {
        throw new Error('Node require is not available in this runtime.');
    }
}
function resolveDocModule(moduleExports) {
    var _a, _b;
    if (moduleExports && typeof moduleExports === 'object' && 'default' in moduleExports) {
        const candidate = moduleExports.default;
        return (_a = candidate) !== null && _a !== void 0 ? _a : (() => null);
    }
    return (_b = moduleExports) !== null && _b !== void 0 ? _b : (() => null);
}
function injectSwaggerUiOverrides() {
    if (typeof document === 'undefined') {
        return;
    }
    if (document.getElementById(SWAGGER_UI_STYLE_ID)) {
        return;
    }
    const style = document.createElement('style');
    style.id = SWAGGER_UI_STYLE_ID;
    style.textContent = SWAGGER_UI_OVERRIDE_CSS;
    document.head.appendChild(style);
}
const DocsGettingStartedPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/getting-started.mdx'))), '@docs/getting-started.mdx');
const DocsAuthContainerOverviewPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/auth-container/overview.mdx'))), '@docs/auth-container/overview.mdx');
const DocsAuthContainerConfigurationPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/auth-container/configuration.mdx'))), '@docs/auth-container/configuration.mdx');
const DocsAuthContainerCommandsPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/auth-container/commands.mdx'))), '@docs/auth-container/commands.mdx');
const DocsAuthContainerNatsEventsPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/auth-container/nats-events.mdx'))), '@docs/auth-container/nats-events.mdx');
const DocsLicenseOperatorOverviewPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/license-operator/overview.mdx'))), '@docs/license-operator/overview.mdx');
const DocsLicenseOperatorConfigurationPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/license-operator/configuration.mdx'))), '@docs/license-operator/configuration.mdx');
const DocsLicenseOperatorNatsEventsPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/license-operator/nats-events.mdx'))), '@docs/license-operator/nats-events.mdx');
const DocsFrameworkGuidePage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/extending-authlance/extending-authlance.mdx'))), '@docs/extending-authlance/extending-authlance.mdx');
const DocsFrameworkRoutingPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/extending-authlance/extending-authlance-routing.mdx'))), '@docs/extending-authlance/extending-authlance-routing.mdx');
const DocsFrameworkContributionsPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/extending-authlance/extending-authlance-contributions.mdx'))), '@docs/extending-authlance/extending-authlance-contributions.mdx');
const DocsFrameworkOperationsPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/extending-authlance/extending-authlance-operations.mdx'))), '@docs/extending-authlance/extending-authlance-operations.mdx');
const DocsDeploymentDevelopmentEnvironmentPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/deployment/development-environment.mdx'))), '@docs/deployment/development-environment.mdx');
const DocsDeploymentDockerPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/deployment/docker-compose.mdx'))), '@docs/deployment/docker-compose.mdx');
const DocsDeploymentHelmPage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/deployment/helm-charts.mdx'))), '@docs/deployment/helm-charts.mdx');
const TermsOfServicePage = createDocPage(() => Promise.resolve().then(() => __importStar(require('@docs/tos.mdx'))), '@docs/tos.mdx');
const AUTH_CONTAINER_OPENAPI_SPEC_URL = '/authlance/identity/api/v1/openapi';
const LICENSE_OPERATOR_OPENAPI_SPEC_URL = '/authlance/license/openapi';
function createSwaggerUiPage(options) {
    const SwaggerPage = () => {
        const [SwaggerComponent, setSwaggerComponent] = react_1.default.useState(null);
        const [loadError, setLoadError] = react_1.default.useState(null);
        react_1.default.useEffect(() => {
            if (typeof window === 'undefined') {
                return;
            }
            let mounted = true;
            const loadSwagger = async () => {
                try {
                    await Promise.resolve().then(() => __importStar(require('swagger-ui-react/swagger-ui.css')));
                    injectSwaggerUiOverrides();
                    const module = await Promise.resolve().then(() => __importStar(require('swagger-ui-react')));
                    if (!mounted) {
                        return;
                    }
                    setSwaggerComponent(() => module.default);
                }
                catch (error) {
                    console.error('Failed to load Swagger UI', error);
                    if (mounted) {
                        setLoadError('Unable to load the Swagger UI bundle.');
                    }
                }
            };
            loadSwagger();
            return () => {
                mounted = false;
            };
        }, []);
        const renderShell = (content) => (react_1.default.createElement("section", { className: "mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 py-10" },
            react_1.default.createElement("header", { className: "space-y-3" },
                react_1.default.createElement("p", { className: "text-sm font-semibold uppercase tracking-wide text-primary/70" }, options.label),
                react_1.default.createElement("div", { className: "space-y-2" },
                    react_1.default.createElement("h1", { className: "text-3xl font-semibold tracking-tight" }, options.title),
                    react_1.default.createElement("p", { className: "text-base text-muted-foreground" }, options.description))),
            content));
        if (loadError) {
            return renderShell(react_1.default.createElement("div", { className: "rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive" }, loadError));
        }
        if (!SwaggerComponent) {
            return renderShell(react_1.default.createElement("div", { className: "rounded-lg border bg-card p-4 text-sm text-muted-foreground" }, DOC_FALLBACK));
        }
        return renderShell(react_1.default.createElement("div", { className: "rounded-xl border bg-card text-card-foreground shadow-sm" },
            react_1.default.createElement(SwaggerComponent, { url: options.specUrl, docExpansion: "list", defaultModelsExpandDepth: 1, defaultModelExpandDepth: 1, defaultModelRendering: "schema", deepLinking: true, displayRequestDuration: true, persistAuthorization: true, showExtensions: true, tryItOutEnabled: true })));
    };
    return SwaggerPage;
}
const DocsAuthContainerOpenApiPage = createSwaggerUiPage({
    label: 'Auth Container',
    title: 'Identity API Reference',
    description: `Explore the identity endpoints exposed at ${AUTH_CONTAINER_OPENAPI_SPEC_URL} and exercise them via Swagger UI.`,
    specUrl: AUTH_CONTAINER_OPENAPI_SPEC_URL,
});
const DocsLicenseOperatorOpenApiPage = createSwaggerUiPage({
    label: 'License Operator',
    title: 'License Operator API Reference',
    description: `Inspect and try the license issuance endpoints exposed at ${LICENSE_OPERATOR_OPENAPI_SPEC_URL}.`,
    specUrl: LICENSE_OPERATOR_OPENAPI_SPEC_URL,
});
let DocsGettingStartedPageContribution = class DocsGettingStartedPageContribution {
    getRoute() {
        return {
            path: '/docs',
            component: DocsGettingStartedPage,
            icon: react_1.default.createElement(lucide_react_1.BookOpen, null),
            navBar: true,
            name: 'Getting Started',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            prerender: getDocPrerenderConfig('/docs'),
        };
    }
};
exports.DocsGettingStartedPageContribution = DocsGettingStartedPageContribution;
exports.DocsGettingStartedPageContribution = DocsGettingStartedPageContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsGettingStartedPageContribution);
let DocsAuthContainerOverviewContribution = class DocsAuthContainerOverviewContribution {
    getRoute() {
        return {
            path: '/docs/auth-container/overview',
            component: DocsAuthContainerOverviewPage,
            icon: react_1.default.createElement(lucide_react_1.TableOfContents, null),
            navBar: true,
            name: '1. Overview',
            exact: true,
            root: true,
            forceParent: '/',
            authRequired: false,
            category: AUTH_CONTAINER_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/auth-container/overview'),
        };
    }
};
exports.DocsAuthContainerOverviewContribution = DocsAuthContainerOverviewContribution;
exports.DocsAuthContainerOverviewContribution = DocsAuthContainerOverviewContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsAuthContainerOverviewContribution);
let DocsAuthContainerConfigurationContribution = class DocsAuthContainerConfigurationContribution {
    getRoute() {
        return {
            path: '/docs/auth-container/configuration',
            component: DocsAuthContainerConfigurationPage,
            icon: react_1.default.createElement(lucide_react_1.Settings, null),
            navBar: true,
            name: '2. Configuration',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: AUTH_CONTAINER_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/auth-container/configuration'),
        };
    }
};
exports.DocsAuthContainerConfigurationContribution = DocsAuthContainerConfigurationContribution;
exports.DocsAuthContainerConfigurationContribution = DocsAuthContainerConfigurationContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsAuthContainerConfigurationContribution);
let DocsAuthContainerCommandsContribution = class DocsAuthContainerCommandsContribution {
    getRoute() {
        return {
            path: '/docs/auth-container/commands',
            component: DocsAuthContainerCommandsPage,
            icon: react_1.default.createElement(lucide_react_1.SquareChevronRight, null),
            navBar: true,
            name: '3. Commands',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: AUTH_CONTAINER_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/auth-container/commands'),
        };
    }
};
exports.DocsAuthContainerCommandsContribution = DocsAuthContainerCommandsContribution;
exports.DocsAuthContainerCommandsContribution = DocsAuthContainerCommandsContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsAuthContainerCommandsContribution);
let DocsAuthContainerNatsEventsContribution = class DocsAuthContainerNatsEventsContribution {
    getRoute() {
        return {
            path: '/docs/auth-container/nats-events',
            component: DocsAuthContainerNatsEventsPage,
            icon: react_1.default.createElement(lucide_react_1.Radio, null),
            navBar: true,
            name: '4. NATS Events',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: AUTH_CONTAINER_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/auth-container/nats-events'),
        };
    }
};
exports.DocsAuthContainerNatsEventsContribution = DocsAuthContainerNatsEventsContribution;
exports.DocsAuthContainerNatsEventsContribution = DocsAuthContainerNatsEventsContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsAuthContainerNatsEventsContribution);
let DocsAuthContainerOpenApiContribution = class DocsAuthContainerOpenApiContribution {
    getRoute() {
        return {
            path: '/docs/auth-container/openapi',
            component: DocsAuthContainerOpenApiPage,
            icon: react_1.default.createElement(lucide_react_1.Code2, null),
            navBar: true,
            name: '5. API Reference',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: AUTH_CONTAINER_CATEGORY,
            prerender: DOCS_AUTH_CONTAINER_OPENAPI_PRERENDER,
        };
    }
};
exports.DocsAuthContainerOpenApiContribution = DocsAuthContainerOpenApiContribution;
exports.DocsAuthContainerOpenApiContribution = DocsAuthContainerOpenApiContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsAuthContainerOpenApiContribution);
let DocsLicenseOperatorOverviewContribution = class DocsLicenseOperatorOverviewContribution {
    getRoute() {
        return {
            path: '/docs/license-operator/overview',
            component: DocsLicenseOperatorOverviewPage,
            icon: react_1.default.createElement(lucide_react_1.TableOfContents, null),
            navBar: true,
            name: '1. Overview',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: LICENSE_OPERATOR_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/license-operator/overview'),
        };
    }
};
exports.DocsLicenseOperatorOverviewContribution = DocsLicenseOperatorOverviewContribution;
exports.DocsLicenseOperatorOverviewContribution = DocsLicenseOperatorOverviewContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsLicenseOperatorOverviewContribution);
let DocsLicenseOperatorConfigurationContribution = class DocsLicenseOperatorConfigurationContribution {
    getRoute() {
        return {
            path: '/docs/license-operator/configuration',
            component: DocsLicenseOperatorConfigurationPage,
            icon: react_1.default.createElement(lucide_react_1.Settings, null),
            navBar: true,
            name: '2. Configuration',
            exact: true,
            root: true,
            forceParent: '/',
            authRequired: false,
            category: LICENSE_OPERATOR_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/license-operator/configuration'),
        };
    }
};
exports.DocsLicenseOperatorConfigurationContribution = DocsLicenseOperatorConfigurationContribution;
exports.DocsLicenseOperatorConfigurationContribution = DocsLicenseOperatorConfigurationContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsLicenseOperatorConfigurationContribution);
let DocsLicenseOperatorNatsEventsContribution = class DocsLicenseOperatorNatsEventsContribution {
    getRoute() {
        return {
            path: '/docs/license-operator/nats-events',
            component: DocsLicenseOperatorNatsEventsPage,
            icon: react_1.default.createElement(lucide_react_1.Radio, null),
            navBar: true,
            name: '3. NATS Events',
            exact: true,
            root: true,
            forceParent: '/',
            authRequired: false,
            category: LICENSE_OPERATOR_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/license-operator/nats-events'),
        };
    }
};
exports.DocsLicenseOperatorNatsEventsContribution = DocsLicenseOperatorNatsEventsContribution;
exports.DocsLicenseOperatorNatsEventsContribution = DocsLicenseOperatorNatsEventsContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsLicenseOperatorNatsEventsContribution);
let DocsLicenseOperatorOpenApiContribution = class DocsLicenseOperatorOpenApiContribution {
    getRoute() {
        return {
            path: '/docs/license-operator/openapi',
            component: DocsLicenseOperatorOpenApiPage,
            icon: react_1.default.createElement(lucide_react_1.Code2, null),
            navBar: true,
            name: '4. API Reference',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: LICENSE_OPERATOR_CATEGORY,
            prerender: DOCS_LICENSE_OPERATOR_OPENAPI_PRERENDER,
        };
    }
};
exports.DocsLicenseOperatorOpenApiContribution = DocsLicenseOperatorOpenApiContribution;
exports.DocsLicenseOperatorOpenApiContribution = DocsLicenseOperatorOpenApiContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsLicenseOperatorOpenApiContribution);
let DocsFrameworkGuideContribution = class DocsFrameworkGuideContribution {
    getRoute() {
        return {
            path: '/docs/framework/extending-authlance',
            component: DocsFrameworkGuidePage,
            icon: react_1.default.createElement(lucide_react_1.Lightbulb, null),
            navBar: true,
            name: '1. Authlance Extension Guide',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: FRAMEWORK_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/framework/extending-authlance'),
        };
    }
};
exports.DocsFrameworkGuideContribution = DocsFrameworkGuideContribution;
exports.DocsFrameworkGuideContribution = DocsFrameworkGuideContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsFrameworkGuideContribution);
let DocsFrameworkRoutingContribution = class DocsFrameworkRoutingContribution {
    getRoute() {
        return {
            path: '/docs/framework/extending-authlance-routing',
            component: DocsFrameworkRoutingPage,
            icon: react_1.default.createElement(lucide_react_1.Route, null),
            navBar: true,
            name: '3. Routing & Metadata',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: FRAMEWORK_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/framework/extending-authlance-routing'),
        };
    }
};
exports.DocsFrameworkRoutingContribution = DocsFrameworkRoutingContribution;
exports.DocsFrameworkRoutingContribution = DocsFrameworkRoutingContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsFrameworkRoutingContribution);
let DocsFrameworkContributionsContribution = class DocsFrameworkContributionsContribution {
    getRoute() {
        return {
            path: '/docs/framework/extending-authlance-contributions',
            component: DocsFrameworkContributionsPage,
            icon: react_1.default.createElement(lucide_react_1.Workflow, null),
            navBar: true,
            name: '4. Prerender & Runtime',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: FRAMEWORK_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/framework/extending-authlance-contributions'),
        };
    }
};
exports.DocsFrameworkContributionsContribution = DocsFrameworkContributionsContribution;
exports.DocsFrameworkContributionsContribution = DocsFrameworkContributionsContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsFrameworkContributionsContribution);
let DocsFrameworkOperationsContribution = class DocsFrameworkOperationsContribution {
    getRoute() {
        return {
            path: '/docs/framework/extending-authlance-operations',
            component: DocsFrameworkOperationsPage,
            icon: react_1.default.createElement(lucide_react_1.Palette, null),
            navBar: true,
            name: '2. Layout & Operations',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: FRAMEWORK_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/framework/extending-authlance-operations'),
        };
    }
};
exports.DocsFrameworkOperationsContribution = DocsFrameworkOperationsContribution;
exports.DocsFrameworkOperationsContribution = DocsFrameworkOperationsContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsFrameworkOperationsContribution);
let DocsDeploymentDevelopmentEnvironmentContribution = class DocsDeploymentDevelopmentEnvironmentContribution {
    getRoute() {
        return {
            path: '/docs/deployment/development-environment',
            component: DocsDeploymentDevelopmentEnvironmentPage,
            icon: react_1.default.createElement(lucide_react_1.Monitor, null),
            navBar: true,
            name: '3. Development Environment',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: DEPLOYMENT_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/deployment/development-environment'),
        };
    }
};
exports.DocsDeploymentDevelopmentEnvironmentContribution = DocsDeploymentDevelopmentEnvironmentContribution;
exports.DocsDeploymentDevelopmentEnvironmentContribution = DocsDeploymentDevelopmentEnvironmentContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsDeploymentDevelopmentEnvironmentContribution);
let DocsDeploymentDockerContribution = class DocsDeploymentDockerContribution {
    getRoute() {
        return {
            path: '/docs/deployment/docker-compose',
            component: DocsDeploymentDockerPage,
            icon: react_1.default.createElement(lucide_react_1.Boxes, null),
            navBar: true,
            name: '1. Docker Compose Deployment',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: DEPLOYMENT_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/deployment/docker-compose'),
        };
    }
};
exports.DocsDeploymentDockerContribution = DocsDeploymentDockerContribution;
exports.DocsDeploymentDockerContribution = DocsDeploymentDockerContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsDeploymentDockerContribution);
let DocsDeploymentHelmContribution = class DocsDeploymentHelmContribution {
    getRoute() {
        return {
            path: '/docs/deployment/helm-charts',
            component: DocsDeploymentHelmPage,
            icon: react_1.default.createElement(lucide_react_1.Sailboat, null),
            navBar: true,
            name: '2. Helm Chart Deployment',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            category: DEPLOYMENT_CATEGORY,
            prerender: getDocPrerenderConfig('/docs/deployment/helm-charts'),
        };
    }
};
exports.DocsDeploymentHelmContribution = DocsDeploymentHelmContribution;
exports.DocsDeploymentHelmContribution = DocsDeploymentHelmContribution = __decorate([
    (0, inversify_1.injectable)()
], DocsDeploymentHelmContribution);
let TermsOfServiceContribution = class TermsOfServiceContribution {
    getRoute() {
        return {
            path: '/terms-of-service',
            component: TermsOfServicePage,
            icon: react_1.default.createElement(lucide_react_1.FileText, null),
            navBar: false,
            name: '',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            prerender: getDocPrerenderConfig('/terms-of-service'),
        };
    }
};
exports.TermsOfServiceContribution = TermsOfServiceContribution;
exports.TermsOfServiceContribution = TermsOfServiceContribution = __decorate([
    (0, inversify_1.injectable)()
], TermsOfServiceContribution);
exports.default = DocsGettingStartedPage;
